
<template>
  <div class="pipe-editor-holder" id="pipe-editor" :class="isMonochrome">
    <svg width="100%" height="100%" id="pipeEditor" ref="pipeEditor" style="position: absolute;">
      <defs>
        <filter id="drop-shadow-1" filterUnits="userSpaceOnUse">
          <feOffset dx="1.72" dy=".86"/>
          <feGaussianBlur result="blur" stdDeviation=".86"/>
          <feFlood flood-color="#000" flood-opacity=".12"/>
          <feComposite in2="blur" operator="in"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <defs v-html="getPatternDefs"></defs>
      <Grid type="grid"/>
      <g id="compositeHolder" :transform="'translate(' + ( getOffsetL ) + ',0)'">
        <Composite/>
      </g>
      <g id="editorHolder" :transform="'translate(' + ( getOffsetL ) + ',0)'">
        <Pipe v-for="(segment, index) in getPipeSegments"
          :ref="'pipe' + index"
          :key="index"
          :segment="segment"
          :num="index"
        />
        <Slope v-for="(segment, index) in getSlopeSegments"
          :ref="'slope' + index"
          :key="index"
          :segment="segment"
          :num="index"
        />
        <Split/>
      </g>
      <Offset side="left"/>
      <Offset side="right"/>
      <Trim/>
      <Extend/>
      <Inlet/>
    </svg>
  </div>
</template>

<script>
import Inlet from '@/components/layout/pipe_editor/pipe_editor_components/Inlet';
import Pipe from '@/components/layout/pipe_editor/pipe_editor_components/Pipe';
import { useSegmentStore } from '@/store/SegmentStore';
import Grid from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/Grid.vue';
import Split from '@/components/layout/pipe_editor/pipe_editor_components/Split';
import Slope from '@/components/layout/pipe_editor/pipe_editor_components/Slope';
import Composite from '@/components/layout/pipe_editor/pipe_editor_components/Composite';
import Offset from '@/components/layout/pipe_editor/pipe_editor_components/Offset';
import { useInputStore } from '@/store/InputStore';
import Trim from '@/components/layout/pipe_editor/pipe_editor_components/Trim';
import Extend from '@/components/layout/pipe_editor/pipe_editor_components/Extend';
import { usePrintStore } from '@/store/PrintStore';
import { useSettingsStore } from '@/store/SettingsStore';


export default {
  name: 'PipeEditor',
  components: {
    Pipe, 
    Inlet,
    Grid,
    Split,
    Slope,
    Composite,
    Offset,
    Trim,
    Extend
  },
  props: [
    'type'
  ],
  data () {
    return {
      scale: 1500
    };
  },
  mounted () {
    // generate shades of colors (working, but may not implement)

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    // todo: this is the best approach to handle responsive svgs
    const resizeObserver = new ResizeObserver(this.handleResize);
    resizeObserver.observe(this.$refs.pipeEditor);
    // resizeObserver.observe(document.getElementById('pipeEditor'));
  },
  watch: {
    getSelectedPipeNum (to, from) {
      this.highlightSegment(to, from, 'pipe');
    },
    getSelectedSlopeNum (to, from) {
      this.highlightSegment(to, from, 'slope');
    },
    printCancel: {
      handler () {
        this.handleResize();
      }
    }
  },
  computed: {
    isMonochrome () {
      return (useSettingsStore().getIsMonochrome) ? 'monochrome' : '';
    },
    printCancel () {
      return usePrintStore().getPrintIsOpen;
    },
    getPatternDefs () {
      return useSegmentStore().getPatternDefs;
    },
    getSelectedPipeNum () {
      return useSegmentStore().getSelectedPipeNum;
    },
    getSelectedSlopeNum () {
      return useSegmentStore().getSelectedSlopeNum;
    },
    getPipeSegments () {
      return useSegmentStore().getSegments('pipe');
    },
    getSlopeSegments () {
      return useSegmentStore().getSegments('slope');
    },
    getOffsetL () {
      return useInputStore().getXAxisGap;
    }
  },
  methods: {
    handleResize () {
      // eslint-disable-next-line no-unreachable
      if (this.$refs.pipeEditor === null) { return; }

      const inputStore = useInputStore();
      const segmentStore = useSegmentStore();
      const printStore = usePrintStore();
      if (printStore.getPrintIsOpen && this.type === 'print') {
        inputStore.setPipeEditorWidth(this.$refs.pipeEditor.clientHeight);
        segmentStore.setPipeEditorHeight(this.$refs.pipeEditor.clientHeight);
        return;
      }
      if (this.$refs.pipeEditor.clientWidth != null && this.$refs.pipeEditor.clientHeight != null && !printStore.getPrintIsOpen) {
        inputStore.setPipeEditorWidth(this.$refs.pipeEditor.getBoundingClientRect().width);
        segmentStore.setPipeEditorHeight(this.$refs.pipeEditor.getBoundingClientRect().height);
      }
    },
    highlightSegment (to, from, type) {
      if (from !== null && parseInt(from) !== useSegmentStore().numberOfSegmentsOfType(type)) {
        this.$refs[type + from][0].removeHighlight();
      }
      if (to !== null) {
        this.$refs[type + to][0].highlight();
      }
    },
  }
};
</script>

<style scoped>
.pipe-editor-holder {
  width: 100%;
  position: relative;
  overflow-y: hidden;
  flex: 5;
}
.segment {
  cursor: pointer;
}
</style>

<style>
.monochrome {
  filter: grayscale(100%);
}
</style>